import React, {Fragment} from 'react';
import PageTitle from '../../../Layout/AppMain/PageTitle';
import Tabs from 'react-responsive-tabs';
import Escuelas from './component/Escuelas';





export default class EscuelasComponent extends React.Component {

    render() {

        return (
            <Escuelas></Escuelas>
        );
    }
}


// WEBPACK FOOTER //
// src/Pages/Demografico/Escuelas/index.js